import { Field, useFormikContext } from "formik";
import { makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "formik-material-ui-lab";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "block",
    maxWidth: "100%",
    marginBottom: theme.spacing(0.75),
  },
}));

export default function FormikAutocomplete({ name, label, options, idPrefix, inputProps = {}, ...props }) {
  const formik = useFormikContext();
  const classes = useStyles();

  function filterOptions(optionList, state) {
    // No filtering if nothing entered
    if (!state || !state.inputValue) {
      return optionList;
    }

    // Limit the list to only options STARTING with what the user typed
    return optionList.filter((option) => {
      return option.toUpperCase().startsWith(state.inputValue.toUpperCase());
    });
  }

  return (
    <Field
      name={name}
      component={Autocomplete}
      options={options}
      className={classes.root}
      {...props}
      id={(idPrefix ? idPrefix : "") + name}
      freeSolo
      filterOptions={filterOptions}
      renderInput={(params) => (
        <TextField
          {...params}
          error={formik.touched[name] && !!formik.errors[name]}
          helperText={formik.errors[name]}
          label={label}
          {...inputProps}
          FormHelperTextProps={{ "data-cy": (idPrefix ? idPrefix + "-" + name : name) + "-helper-text" }}
        />
      )}
    />
  );
}
